<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="container">
      <div style="border: solid 1px #c9cbd6;">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;min-width:1000px;"
          :header-cell-style="{background:'#F5F5F5'}"
        >
          <el-table-column
            label="问诊发起时间"
            prop="submit_time"
          ></el-table-column>
          <el-table-column
            label="接诊时间"
            prop="agree_time"
          ></el-table-column>
          <el-table-column
            label="问诊费用"
            prop="pay_money"
          ></el-table-column>
          <el-table-column
            label="科室"
            prop="department_name"
          ></el-table-column>

          <el-table-column
            prop="doctor_name"
            label="医生姓名"
          >
            <template slot-scope="scope">
              <span
                @click="showDocMsg(scope.row.doctor_id)"
                style="cursor:pointer"
              >{{scope.row.doctor_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="职称"
            prop="title"
          ></el-table-column>
          <el-table-column
            label="手机号"
            prop="phone"
          ></el-table-column>

          <el-table-column label="咨询状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==1">待提问</span>
              <span v-if="scope.row.status==2">待确认</span>
              <span v-if="scope.row.status==3">咨询中</span>
              <span v-if="scope.row.status==4">拒绝接诊</span>
              <span v-if="scope.row.status==5">问诊时间结束</span>
              <span v-if="scope.row.status==6">超时未接诊</span>
              <span v-if="scope.row.status==7">手动结束</span>
              <span v-if="scope.row.status==8">超时未发起</span>
              <div
                v-if="scope.row.status==4"
                style="color:#f24b2f"
              >原因：{{scope.row.refuse_desc}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toDetail(scope.row.consult_id)"
                :disabled="module_id_array[0]?!module_id_array.includes('50'):false"
              >查看记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import platform from '../../../api/platform';
import yewu from '../../../api/yewu';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      tableData: [],
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取问诊记录列表
    getLogList() {
      let data = {
        page: 1,
        pageNumber: 1000,
        patient_id: this.$route.query.patient_id,
        consult_status: 0
      };
      yewu
        .consultList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.submit_time = item.submit_time
                ? platform.timestampToTime(item.submit_time)
                : '-------';
              item.agree_time = item.agree_time
                ? platform.timestampToTime(item.agree_time)
                : '-------';
              return item;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //详情
    toDetail(consult_id) {
      this.$router.push({
        path: '/home/yewu/wenzhendetail',
        query: {
          consult_id
        }
      });
    }
  },
  created() {
    this.getLogList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 205px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>


